import {OurFeedbackSvc} from '../services/OurFeedbackSvc';

class FeedBacksList {
    feedbacks: IFeedBack[];

    constructor(private OurFeedbackSvc: OurFeedbackSvc) {
        this.feedbacks = this.OurFeedbackSvc.getForPage();
    }
}

angular.module('animatronApp.feedback').component('feedbacksList', {
    controller: FeedBacksList,
    templateUrl: require('feedbacks-list.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/feedbacksListDirective.ts